import * as React from 'react';

import { trackNavBarClick, trackNavBarMortgageShow } from './tracking';
import { useIntersectionVisibleOnce } from '../../hooks/useIntersectionVisibleOnce';
import { ERubric } from '../../types/rubricsLinks';

interface INavBarNavItemProps {
  rubric: ERubric;
  title: string;
  url?: string | null;
  className: string;
  linkClassName: string;
  onItemMouseOver(rubric: ERubric): void;
  onItemMouseOut(): void;
}

export const NavBarNavItem: React.FC<INavBarNavItemProps> = ({
  rubric,
  title,
  url,
  className,
  linkClassName,
  onItemMouseOut,
  onItemMouseOver,
}) => {
  const mortgageVisibleRef = useIntersectionVisibleOnce(trackNavBarMortgageShow, {
    enabled: rubric === ERubric.Mortgage,
  });

  return (
    <li
      data-testid="nav-item"
      ref={rubric === ERubric.Mortgage ? mortgageVisibleRef : undefined}
      className={className}
      onMouseOver={() => onItemMouseOver(rubric)}
      onMouseOut={onItemMouseOut}
    >
      {url && (
        <a className={linkClassName} href={url} onClick={() => trackNavBarClick(rubric, url)}>
          {title}
        </a>
      )}
      {!url && (
        <span data-testid="title" className={linkClassName} onClick={() => trackNavBarClick(rubric)}>
          {title}
        </span>
      )}
    </li>
  );
};
